import React, { FC, useMemo } from 'react';

import { Column, DataGrid, Export, Summary, TotalItem } from 'devextreme-react/data-grid';

import { Workbook } from 'exceljs';

import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver-es';
import $createStore from 'utils/create-store-instance';

const SecondaryDetailTemplate: FC<any> = (props) => {
  const shiftDateSource: any = useMemo(
    () => $createStore(`/v1/Shift/${props.data.data.shiftId}/${props.data.data.requestId}`, 'id'),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const onExporting = (e: any) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('1');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    });
    e.cancel = true;
  };

  return (
    <React.Fragment>
      <DataGrid dataSource={shiftDateSource} showBorders={true} columnAutoWidth={true} onExporting={onExporting}>
        <Column dataField="number" caption="Номер отгрузки" width={120} />
        <Column dataField="date" caption="Дата" dataType="datetime" />
        <Column dataField="transport" caption="Транспорт" />
        <Column dataField="driver" caption="Водитель" />
        <Column dataField="operator" caption="Оператор" />
        <Column dataField="quantity" caption="Объем" width={80} />
        <Column dataField="fault" caption="Погрешность" width={100} />
        <Summary>
          <TotalItem
            column="quantity"
            summaryType="sum"
            //customizeText={(data: any) => `Итого: ${data.value}`}
          />
          <TotalItem
            column="fault"
            summaryType="sum"
            //customizeText={(data: any) => `Итого: ${data.value}`}
          />
        </Summary>
        <Export enabled={true} />
      </DataGrid>
    </React.Fragment>
  );
};

export default SecondaryDetailTemplate;
